import { Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface MiddlewareExitIntentActionInput {
  variant: 'control' | 'variantA' | 'variantB';
  dealId?: string | {};
}

export interface MiddlewareExitIntentActionOutput {
  success: boolean;
  variant: string;
  action: 'dismissed' | 'accepted' | 'trial';
}

@Injectable({
  providedIn: 'root',
})
export class MiddlewareExitIntentAction {
  private isShowingModal = signal(false);

  constructor() {}

  run(input: MiddlewareExitIntentActionInput): Observable<MiddlewareExitIntentActionOutput> {
    if (input.variant === 'control') {
      return of({
        success: false,
        variant: 'control',
        action: 'dismissed'
      });
    }

    if (!this.isShowingModal()) {
      this.isShowingModal.set(true);
    }

    return of({
      success: true,
      variant: input.variant,
      action: 'trial'
    });
  }


  get showModal(): boolean {
    return this.isShowingModal();
  }
  
  setModalState(isShowing: boolean): void {
    this.isShowingModal.set(isShowing);
  }
 
  dismissModal(): void {
    this.isShowingModal.set(false);
  }
}
